import { rem, spacing } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../../helpers';

export const tag = tagName('confirmation-modal');

export const styles = [
  css`
    :host {
      --width: ${rem(450)};
    }

    :where(dialog) {
      inline-size: var(--width);
    }

    footer {
      display: flex;
      gap: ${spacing(200)};
    }

    :host([sticky-footer]) :where(dialog) {
      display: flex;
      flex-direction: column;
      max-block-size: 80vh; /* Ensure the modal doesn't take too much vertical space */
    }

    :host([sticky-footer]) container {
      block-size: 100%;
      flex: 1;
      overflow-y: auto;
    }

    main {
      flex: 1;
      padding-block: ${spacing(150)};
    }

    :host([sticky-footer]) main {
      overflow-y: auto;
    }

    :host([sticky-footer]) footer {
      flex-shrink: 0;
      /* TODO: no matching spacing token for 10px */
      margin-block-start: ${spacing(100)};
      /* TODO: no matching spacing token for 10px */
      padding: ${spacing(100)};
      position: relative;
    }
  `,
];
